module.exports = __webpack_public_path__ + "img/marmelaedchen-tierchen_xs.792e60e3.jpg";